import { get, post } from "./api.service"

const BASE_URL = process.env.REACT_APP_BASE_URL;
export let me = null;

export const setMe = (data: any) => {
    me = data;
    if (process.env.REACT_APP_USELOCALSTORAGE_TOKEN == 'true') {
        localStorage.setItem('TOKEN', JSON.stringify(data))
    }
}

export const getMe = () => {
    if (process.env.REACT_APP_USELOCALSTORAGE_TOKEN == 'true') {
        let user = localStorage.getItem('TOKEN');
        return user ? JSON.parse(user) : null
    }
    return me
}

export const logout = () => {
    localStorage.removeItem('TOKEN');
    window.location.href = "/";
}

export const login = (data: any): Promise<any> => {
    return post(`${BASE_URL}/accesstoken`, data);
}

export const getData = (): Promise<Response> => {
    return get(`${BASE_URL}/customers`);
}


export const getDetails = (id: any): Promise<Response> => {
    return get(`${BASE_URL}/customers/${id}`)
}


export const getAccess = (id: any): Promise<Response> => {

    return post(`${BASE_URL}/customers/${id}/access`,)
}

export const grantRequest = (id: any, rid: any, date: any): Promise<Response> => {
    return post(`${BASE_URL}/customers/${id}/access/${rid}/grant?tillDate=${date}`)
}


export const getAllPendingRequest = (): Promise<any> => {
    return get(`${BASE_URL}/customers/requests/pending`)
}

export const uploadFile = (file: any): Promise<any> => {
    console.log(file, 'Filesssssssssssssssss')
    const formData = new FormData();
    formData.append('file', file.file);
    return post(`${BASE_URL}/files?contract=${file.fileType}`, formData)
}

export const downloadFile = (fileDmsCode: any): Promise<any> => {
    return get(`${BASE_URL}/files/${fileDmsCode}`, { responseType: "blob" })
}

export const auditCustomer = (did: any): Promise<any> => {
    return get(`${BASE_URL}/customers/${did}/claims`)
}